import React from "react"
import styled from "styled-components"
import {color, position, space} from "styled-system"

import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"

import {faSpinnerThird} from "@fortawesome/pro-regular-svg-icons"

const StyledIcon = styled(FontAwesomeIcon)`
  ${color}
  ${position}
  ${space}
`
const StyledSpinner = styled(StyledIcon)`
  --fa-primary-color: ${props => props.color ?? props.theme?.colors?.primary};
`

const Spinner = ({primaryColor, size, ...rest}) => (
  <StyledSpinner
    color={primaryColor}
    icon={faSpinnerThird}
    size={size ?? undefined}
    spin
    {...rest}
  />
)

export default Spinner
